import { call, put, takeEvery, delay } from 'redux-saga/effects'
import { generateReport } from '../../../src/helpers/reports-helper';

import {
  GET_CLIENTS_REQUESTED,
  PUT_COMPOSEPROFILES_REQUESTED,
  PRINT_CLIENT_PROFILE, GET_FULL_NAME_REQUESTED, GET_DEAL_NUMBER,
} from '../actions/actionTypes'
import {
  getClientsSuccess,
  clientsFailed,
  composeProfilesSuccess,
  composeProfilesFailed,
  printClientInfoFailed, getFullNameDealSuccess, getDealNumberSuccess,
} from '../actions/clientsAction'
import { messages } from '../../helpers/messages'
import { clientService } from '../../services/client-service'
import { searchClients } from '../actions/searchAction'
import {dealService} from "../../services/deals-service";
import {pageFailed} from "../actions/handbookAction";

const getNameDeals = async (payload) => await clientService.getFullNameDeal(payload)
    .then(data => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const getDealNumber = async (payload) => await dealService.getDealNumberOverdue(payload)
    .then(data => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const postClients = async payload =>
  await clientService
    .searchClients(payload)
    .then(({ data: { clients } }) => clients)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const composeProfiles = async payload =>
  await clientService
    .composeProfiles(payload)
    .then(({ data: { updateIdOK } }) => updateIdOK)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

function* fetchGetClients({ payload }) {
  try {
    const clients = yield call(postClients, payload)

    yield put(getClientsSuccess(clients))
  } catch (error) {
    yield put(clientsFailed(error))
  }
}

function* fetchGetDealNumber({payload}) {
  try {
    const data = yield call(() => getDealNumber(payload))
    yield put(getDealNumberSuccess(data))
  } catch (e) {
    yield put(pageFailed(e))
  }
}

function* fetchGetFullNameDeal({payload}) {
  try {
    const data = yield call(() => getNameDeals(payload))
    yield put(getFullNameDealSuccess(data))
  } catch (e) {
    yield put(pageFailed(e))
  }
}


function* fetchComposeProfiles({ payload: { listIds, reqData } }) {
  try {
    const response = yield call(composeProfiles, listIds)

    yield delay(1000)
    yield put(searchClients(reqData))

    yield put(composeProfilesSuccess(response))
  } catch (error) {
    yield put(composeProfilesFailed(error))
  }
}

function* printProfile({ payload }) {
  const { client, reportType } = payload;
  try {
    const endpoint = reportType ? 'EXTENDED_CLIENT_PROFILE' : 'STANDARD_CLIENT_PROFILE'
    yield call(generateReport, endpoint, { 'clientId': client.id.toString() })
  } catch (error) {
    yield put(printClientInfoFailed(error))
  }
}

function* getFullNameDealSaga() {
  yield takeEvery(GET_FULL_NAME_REQUESTED, fetchGetFullNameDeal)
}

function* dealNumberSaga() {
  yield takeEvery(GET_DEAL_NUMBER, fetchGetDealNumber)
}

function* getClientsSaga() {
  yield takeEvery(GET_CLIENTS_REQUESTED, fetchGetClients)
}

function* composeProfilesSaga() {
  yield takeEvery(PUT_COMPOSEPROFILES_REQUESTED, fetchComposeProfiles)
}

function* printClientProfileSaga() {
  yield takeEvery(PRINT_CLIENT_PROFILE, printProfile)
}

export {
  getClientsSaga,
  composeProfilesSaga,
  printClientProfileSaga,
  getFullNameDealSaga,
  dealNumberSaga,
}
